<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M12.0008 4.5715C12.0008 4.1963 11.9269 3.82477 11.7834 3.47812C11.6398 3.13148 11.4293 2.8165 11.164 2.55119C10.8987 2.28589 10.5837 2.07543 10.2371 1.93184C9.89042 1.78825 9.51889 1.71436 9.14369 1.71436H3.42941C2.82974 1.71436 2.24528 1.90303 1.7588 2.25366C1.27233 2.6043 0.908515 3.0991 0.718885 3.66799C0.529254 4.23688 0.523427 4.85102 0.702227 5.42341C0.881028 5.9958 1.2354 6.49742 1.71512 6.85721V13.1429C1.71512 13.446 1.83553 13.7368 2.04985 13.951C2.26419 14.1653 2.55487 14.2858 2.85798 14.2858H9.71512C10.0182 14.2858 10.3089 14.1653 10.5232 13.951C10.7376 13.7368 10.858 13.446 10.858 13.1429V6.85721C11.2135 6.59169 11.502 6.24673 11.7004 5.84985C11.8989 5.45298 12.0018 5.01521 12.0008 4.5715Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.71596 1.71436H12.5731C12.9483 1.71436 13.3198 1.78825 13.6665 1.93184C14.0131 2.07543 14.3281 2.28589 14.5934 2.55119C14.8587 2.8165 15.0692 3.13148 15.2128 3.47812C15.3563 3.82477 15.4302 4.1963 15.4302 4.5715C15.4312 5.01521 15.3283 5.45298 15.1298 5.84985C14.9314 6.24673 14.6429 6.59169 14.2874 6.85721V13.1429C14.2874 13.446 14.1669 13.7368 13.9526 13.951C13.7384 14.1653 13.4476 14.2858 13.1445 14.2858H5.14453"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.286 6.85742H10.8574"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
